import { useAuthStore } from "@/stores/auth-store";
import { workspaceAccessApi } from "@/lib/api/workspaceAccess";

/**
 * Leaves the currently-opened tenant workspace, closing its access session
 * server-side (requirement 5: every workspace access is recorded with a
 * duration). A plain function rather than a hook so it can be called from
 * anywhere - a button handler, an effect on the platform directory that
 * defensively closes a stale session left open by browser back/forward -
 * without needing to thread store values through component props.
 *
 * Fire-and-forget on the API call: the UI has already left the workspace by
 * the time this runs, so there is nothing useful to block on or roll back
 * if the exit call fails - the session simply gets picked up by the next
 * Enter's auto-close instead (see WorkspaceAccessService.Enter).
 */
export function exitWorkspace() {
  const { workspaceSessionId, exitTenant } = useAuthStore.getState();
  exitTenant();
  if (workspaceSessionId) {
    void workspaceAccessApi.exit(workspaceSessionId).catch(() => {});
  }
}
